import React, { Component, useEffect, useRef, useState } from 'react'
import './App.css'
import { Link } from 'react-router-dom'
import ClipLoader from 'react-spinners/ClipLoader'
import Axios from 'axios'
import validator from 'validator'
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import { isValidPhoneNumber } from 'react-phone-number-input'
// import PhoneInput from "react-phone-number-input";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import { API_URL } from './config'

const Business = () => {
  const history = useHistory()
  const [business, setBusiness] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')
  const [response, setResponse] = useState('')
  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [spinning, setSpinning] = useState('none')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [saveBtn, setSaveBtn] = useState('save-btn')
  const [disabled, setDisabled] = useState(false)
  const timeoutRef = useRef(null)

  useEffect(() => {
    document.title = 'Business registration'
  }, [])

  const handleBusiness = (event) => {
    setBusiness(event.target.value)
    setErrorDisplay('none')
  }

  const handleEmail = (event) => {
    setEmail(event.target.value)
    setErrorDisplay('none')
  }

  const handlePassword = (event) => {
    setPass1(event.target.value)
    setErrorDisplay('none')
  }

  const handlePassword2 = (event) => {
    setPass2(event.target.value)
    setErrorDisplay('none')
  }

  const onSubmitForm = async () => {
    setErrorDisplay('none')
    setUpdateDisplay('none')
    setSpinning('block')
    // Clear existing timeout if any
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (business.trim() === '') {
      setError('Enter business name')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (email.trim() === '') {
      setError('Enter your email address')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (!validator.isEmail(email)) {
      setError('Your email address is invalid')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (phone.trim() === '') {
      setError('Enter your phone number')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (pass1.length < 8) {
      setError('Password must be at least 8 characters long.')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (pass1 !== pass2) {
      setError('Make sure both your passwords match')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else {
      setSaveBtn('btn-disabled')
      setDisabled(true)
      const baseURL = `${API_URL}/apps/kscanner/webservices.php?`
      const data = new FormData()
      data.append('account_name', business)
      data.append('phone', phone)
      data.append('email', email)
      data.append('password', pass1)
      data.append('accounttype', 'business')
      data.append('platform', 'web')
      data.append('query', 'VERIFYACCOUNT')

      Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === 'success') {
            localStorage.setItem('verificationAccount', 'BUSINESS')
            history.push({
              pathname: '/verification',
              state: {
                email: email,
                accounttype: 'business',
                password: pass1,
              },
            })
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSpinning('none')
            setUpdateDisplay('block')
          }
          setSaveBtn('save-btn')
          setDisabled(false)
        })
        .catch((error) => {
          alert(error)
          setSaveBtn('save-btn')
          setDisabled(false)
        })
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  return (
    <div className="view">
      {/* <Header /> */}
      <div className="container">
        <div className="row justify-content-center align-content-center login-screen-container w-100">
          <div className="col-lg-5 col-12 align-self-center login-container-adjust pt-5">
            <div className="log-title text-center pt-0">
              <Link to="/">
                <img src={`${API_URL}/karamale.png`} width="170" />
              </Link>
            </div>
            <div className=" BoxDashboardContainer">
              <div className="col-12 text-left p-0 mb-2" style={{ lineHeight: '1rem' }}>
                <span>Sell Tickets with Karamale</span>
                <br />
                <label className="text-12 text-grey">
                  Encrypted ticketing. Real-time insights. Scalable reach
                </label>
              </div>
              <input
                required
                type="text"
                name="business"
                placeholder="Business name"
                value={business}
                onChange={handleBusiness}
              />
              <input
                required
                type="email"
                name="email"
                placeholder="Email address"
                value={email}
                onChange={handleEmail}
              />

              <PhoneInput
                // autoFormat={false}
                disableDropdown={true}
                enableSearch={true}
                showDropdown={false}
                country={'za'}
                value={phone}
                onChange={setPhone}
                inputStyle={{
                  width: '100%',
                  background: '#f0f2f5',
                  height: '2.7em',
                }}
                containerStyle={{ marginBottom: 15 }}
                inputProps={{
                  name: 'phone',
                  required: true,
                }}
              />

              <input
                required
                type="password"
                placeholder="New password"
                value={pass1}
                onChange={handlePassword}
              />

              <input
                required
                type="password"
                placeholder="Confirm password"
                value={pass2}
                onChange={handlePassword2}
              />

              <div className="col-12 response textMedium">{response}</div>
              <div className="">
                <label className="">
                  By signing up, you agree to our &nbsp;
                  <Link to="/terms-conditions" target={'_blank'}>
                    Terms and Conditions.
                  </Link>
                </label>
              </div>
              <button
                onClick={() => onSubmitForm()}
                className={saveBtn + ' w-100 mb-3'}
                disabled={disabled}
              >
                <span
                  style={{
                    display: updateDisplay,
                  }}
                >
                  Sign up
                </span>
                <span
                  style={{
                    display: spinning,
                  }}
                >
                  <ClipLoader
                    color={'grey'}
                    loading={true}
                    // css={override}
                    size={20}
                  />
                </span>
              </button>
              <Link to="/login" style={{ textDecoration: 'none' }}>
                <div className="text-center cancel-btn">Log in</div>
              </Link>
            </div>

            <div className="text-footer text-center pb-4">Seamless ticketing starts here.</div>
          </div>
        </div>
      </div>
      <div className="error-login" style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default Business
